import { ApolloError } from '@apollo/client';

import { useShowMessage } from '../../core-ui';
import { parseApolloError } from './errorHandling';

export function useShowApolloError() {
  const showMessage = useShowMessage();

  return (error: ApolloError) => {
    const message = parseApolloError(error);
    showMessage('error', t('Operation failed: {message}', { message }));
    // eslint-disable-next-line no-console
    console.error(error);
  };
}
